export function fetchLdap($api) {
  return $api.get('/api/v2/ldap/settings');
}

export function fetchLdapDefault($api, kind) {
  return $api.get(`/api/v2/ldap/settings/defaults/${kind}`);
}

export function saveLdap($api, isNew, payload) {
  const method = isNew ? $api.post : $api.put;
  return method.call($api, '/api/v2/ldap/settings/', { data: payload });
}

export function fetchSnmp($api) {
  return $api.get('/api/v2/snmp');
}

export function saveSnmp($api, payload) {
  return $api.put('/api/v2/snmp', payload);
}

export function testSnmpTrap($api, payload) {
  return $api.post('/api/v2/snmp/test', payload);
}
